import { render } from "./IncomeStatement.vue?vue&type=template&id=5782deb6&scoped=true"
import script from "./IncomeStatement.vue?vue&type=script&lang=js"
export * from "./IncomeStatement.vue?vue&type=script&lang=js"

import "./IncomeStatement.vue?vue&type=style&index=0&id=5782deb6&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5782deb6"]])

export default __exports__